import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { AuthGuard } from "../auth/auth-guard.service"
import { StoragePanelComponent } from "./storage-panel/storage-panel.component"

const appRoutes: Routes = [
    {
        path: 'storagePanel',
        component: StoragePanelComponent,
        canActivate: [AuthGuard],
        data: { userRole: ['admin', 'storage'] }
    },
]

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class StoragePanelRoutingModule { };